import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router'; // para usar routerLink
import { HeaderInferiorComponent } from './components/header-inferior/header-inferior.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderSuperiorComponent } from './components/header-superior/header-superior.component';
import { CookieConsentComponent } from './components/cookie-consent/cookie-consent.component';

@NgModule({
  declarations: [HeaderInferiorComponent, FooterComponent, HeaderSuperiorComponent, CookieConsentComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,

  ],
  exports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    HeaderInferiorComponent,
    FooterComponent,
    HeaderSuperiorComponent,
    CookieConsentComponent
  ],
  providers: [],
})
export class CoreModule {}
